import React from "react";
import useEspaceActif, { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";
import "./selecteurEspace.scss";

const OPTIONS = [
  { valeur: ESPACES.ENTREPRISE, libelle: "Entreprise" },
  { valeur: ESPACES.PARTICULIER, libelle: "Particulier" },
];

// Bascule Particulier / Entreprise d'un profil MIXED. Rendu nul pour les autres
// profils. Segmented control autonome : pas de .btn-group, que le projet
// redéfinit en colonne (listes de choix des formulaires).
const SelecteurEspace = ({ className = "", onBascule }) => {
  const { espace, peutBasculer, basculer } = useEspaceActif();
  if (!peutBasculer) return null;

  return (
    <div className={`selecteur-espace ${className}`} role="group" aria-label="Espace affiché">
      {OPTIONS.map(({ valeur, libelle }) => (
        <button
          key={valeur}
          type="button"
          onClick={() => {
            basculer(valeur);
            if (onBascule) onBascule();
          }}
          aria-pressed={espace === valeur}
          className={`selecteur-espace__option ${espace === valeur ? "is-active" : ""}`}
        >
          {libelle}
        </button>
      ))}
    </div>
  );
};

export default SelecteurEspace;
